/* 删除日志管理 */
export default {
  // 查询删除文件日志
  getDeleteFileLogs: {
    url: "/deleteApi/getDeleteFileLogs",
    method: "post"
  },
  // 文件已彻底删除 修改文件删除日志状态
  fileThroughtDelete: {
    url: "/deleteApi/fileThroughtDelete",
    method: "get"
  },
  // 查询删除日志详情
  getDeleteLogDetail: {
    url: "/deleteApi/getDeleteLogDetail",
    method: "get"
  },
}
